import { format } from "timeago.js";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { switchNotifState } from "../redux/apiCalls";

const Container = styled.div`
  padding: 10px 15px;
  width: 500px;
  height: 500px;
  position: fixed;
  top: 55px;
  right: 210px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.soft};
  background-color: ${({ theme }) => theme.bgLighter};
  color: ${({ theme }) => theme.text};
  overflow-y: scroll;
  z-index: 9999;
  @media only screen and (max-width: 767px) {
    right: 0px;
    left: 0;
    margin: auto;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.soft};
`;

const ModalTitle = styled.h1`
  font-size: 20px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
const NotifContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  /* background-color: ${({ isRead }) => (isRead ? "white" : "blue")}; */

  &:hover {
    background-color: ${({ theme }) => theme.soft};
    cursor: pointer;
  }
`;

const NotifDesc = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    font-size: 14px;
  }
`;
const NotifTime = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.textSoft};
  margin-top: 5px;
`;

const NotifModal = ({ currentNotifications, setOpenNotifModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = async (e) => {
    e.preventDefault();
    const actualNotif = await currentNotifications?.filter(
      (notif) => notif?._id === e.currentTarget.id
    );
    const actualNotifId = await actualNotif[0]._id;
    const videoId = await actualNotif[0].videoId;
    navigate(`/video/${videoId}`);
    setOpenNotifModal(false);
    switchNotifState(dispatch, actualNotifId);
  };

  // const notifIsReadTrue = currentNotifications.filter(
  //   (notif) => notif.isRead === true
  // );
  // console.log(notifIsReadTrue);

  return (
    <>
      <Container>
        <Wrapper>
          <ModalTitle>Notifications</ModalTitle>
          <Hr />
          {currentNotifications &&
            currentNotifications?.map((notif) => (
              <NotifContent
                id={notif?._id}
                key={notif?._id}
                onClick={handleClick}
                // isRead={isRead}
              >
                <NotifDesc>{notif?.content}</NotifDesc>
                <NotifTime> {format(notif?.createdAt)}</NotifTime>
              </NotifContent>
            ))}
        </Wrapper>
      </Container>
    </>
  );
};

export default NotifModal;
